var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.333,
    height: 16,
    viewBox: "0 0 13.333 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 13.24a3.018 3.018 0 0 1-.651 1.948 1.951 1.951 0 0 1-1.567.812h-8.9a1.95 1.95 0 0 1-1.568-.812A3.021 3.021 0 0 1 0 13.24a14.986 14.986 0 0 1 .088-1.672 8.979 8.979 0 0 1 .328-1.584 5.268 5.268 0 0 1 .61-1.364A2.918 2.918 0 0 1 2 7.692a2.7 2.7 0 0 1 1.4-.359 4.5 4.5 0 0 0 3.26 1.333 4.5 4.5 0 0 0 3.26-1.333 2.7 2.7 0 0 1 1.4.36 2.918 2.918 0 0 1 .979.927 5.268 5.268 0 0 1 .609 1.364 8.979 8.979 0 0 1 .328 1.584 14.986 14.986 0 0 1 .088 1.672zM10.667 4a3.853 3.853 0 0 1-1.172 2.828A3.856 3.856 0 0 1 6.667 8a3.851 3.851 0 0 1-2.828-1.172A3.855 3.855 0 0 1 2.667 4a3.855 3.855 0 0 1 1.172-2.828A3.851 3.851 0 0 1 6.667 0a3.856 3.856 0 0 1 2.828 1.172A3.853 3.853 0 0 1 10.667 4z",
    fill: "#3c2f87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.804376ea19dfcd9d725f01c90ac817b6.svg";
export { ForwardRef as ReactComponent };